import { Box } from '@mui/system';
import { style } from './style';

type TabPanelProps = {
  children: React.ReactNode,
  isTabVisible: boolean;
};

export const TabPanel = (props: TabPanelProps): JSX.Element | null => {
  const {
    children,
    isTabVisible,
  } = props;

  return (
    <Box sx={ style.tabPanel.sx } role="tabpanel" hidden={ !isTabVisible }>
      {children}
    </Box>
  );
};
